import { apiPost } from '.';
import { message } from 'antd';

/**
 * Запрос серий продуктов
 */
const apiUserSet = async (id, user) => {
  const { err, errmsg } = await apiPost('/user/set', { id, data: user });
  if (err) {
    if (Array.isArray(errmsg)) {
      for (const em of errmsg) {
        message.error(em.message, 4);
      }
    } else {
      message.error(errmsg || `Net error: ${err}`);
    }
  }
  return { err };
};
export default apiUserSet;
